import React, { useState, useEffect } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap";
import { FA } from "components/FA";
import { Loading } from "components/Utils";

const CallToAction = ({
  value = null,
  className = null,
  items = [],
  split = false,
  disabled = false,
  emptyLabel = "Please choose...",
  color = "secondary",
  size = null,
  addonType = null,
  spinner = false,
  caret = true,
  right = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [current, setCurrent] = useState(
    items.find((item) => item.value === value)
  );

  const handleToggle = () => setIsOpen(!isOpen);
  const handleClick = (item) => {
    if (caret) {
      setCurrent(item);
    }
    if (typeof item.action === "function") {
      item.action();
    }
  };

  // Update labels (if changed)
  useEffect(() => setCurrent(items.find((item) => item.value === value)), [
    items,
    value,
  ]);

  if (items.length === 1) {
    return (
      <Button
        className={className}
        size={size}
        color={color}
        onClick={() => items[0].action()}
        disabled={disabled || spinner}
        title={items[0].label}
      >
        {spinner && <Loading />}
        {items[0].icon && (
          <>
            <FA icon={items[0].icon} size="xs" />{" "}
          </>
        )}
        <span className="label">{items[0].label}</span>
      </Button>
    );
  }

  return (
    <ButtonDropdown
      className={className}
      isOpen={isOpen}
      toggle={handleToggle}
      addonType={addonType}
    >
      {split && current ? (
        <>
          <Button
            color={color}
            size={size}
            onClick={() => current.action()}
            disabled={disabled || spinner}
          >
            {spinner && <Loading />}
            {current.icon && (
              <>
                <FA icon={current.icon} size="xs" />{" "}
              </>
            )}
            <span className="label">{current.label}</span>
          </Button>
          <DropdownToggle
            className="dropdown-toggle-split"
            caret={caret}
            color={color}
            size={size}
            disabled={disabled || spinner}
          />
        </>
      ) : (
        <DropdownToggle
          caret={caret}
          color={color}
          size={size}
          disabled={disabled || spinner}
        >
          {current == null ? (
            emptyLabel
          ) : (
            <>
              {spinner && <Loading />}
              {current.icon && (
                <>
                  <FA icon={current.icon} size="xs" />{" "}
                </>
              )}
              <span className="label">{current.label}</span>
            </>
          )}
        </DropdownToggle>
      )}
      <DropdownMenu right={right}>
        {items.map((item, i) =>
          item.value == null ? (
            <div key={`divider-${i}`} className="dropdown-divider"></div>
          ) : (
            <DropdownItem key={item.value} onClick={() => handleClick(item)}>
              {item.icon && (
                <>
                  <FA icon={item.icon} size="xs" />{" "}
                </>
              )}
              <span className="label">{item.label}</span>
            </DropdownItem>
          )
        )}
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export { CallToAction };
